import React from "react";
import "./Profeature.scss";
import { useHistory } from "react-router";
import Modal from "react-bootstrap/Modal";
function Profeature(props) {
  const history = useHistory();
  const handlePayment = () => {
    history.push("/pricingplansnew");
  };

  return (
    <>
      <Modal
        {...props}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="profeature-modal"
      >
        <Modal.Body>
          <img
            onClick={props.onHide}
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
            alt="closeicon"
            className="close"
          />
          <div className="">
            <div className="d-flex justify-content-between">
              <div className="profeature-left-image">
                {/* <img
                  src="/images/profeature.png"
                  alt="profeature"
                  className="popupimage"
                /> */}
              </div>

              <div className="px-3">
                <div className="">
                  {props && props.popupType && props.popupType == "resume" ? (
                    <>
                      <h4 className="header-feature mb-3">
                        You've Reached Your Free Limit.{" "}
                      </h4>
                      <p className="sub-text-feature mb-4">
                        Congratulations on creating your first free resume and
                        cover letter! But don't let your job search stop there.
                        Upgrade your plan now to take advantage of unlimited
                        resumes and cover letters, so you can customize your
                        applications for every job you apply to.
                      </p>
                      <p className="sub-text-feature">Also Unlock:</p>
                      <p className="sub-text-feature">
                        <i class="fa fa-check" aria-hidden="true"></i> Access to
                        all premium templates and features, designed by industry
                        experts
                      </p>
                      <p className="sub-text-feature">
                        <i class="fa fa-check" aria-hidden="true"></i> Create as
                        many cover letters as you need to customize your job
                        applications
                      </p>
                      <p className="sub-text-feature">
                        <i class="fa fa-check" aria-hidden="true"></i>{" "}
                        Personalized support and guidance from our team of
                        experts
                      </p>
                    </>
                  ) : props &&
                    props.popupType &&
                    props.popupType == "download" ? (
                    <>
                      <h4 className="header-feature mb-3">
                        Unlock Premium Templates and Features
                      </h4>
                      <p className="sub-text-feature mb-4">
                        Sorry, this premium template is only available to users
                        on our premium plan. Upgrade now to unlock a variety of
                        premium templates and features, including:
                      </p>
                      <p className="sub-text-feature">
                        <i class="fa fa-check" aria-hidden="true"></i> Unlimited
                        use of all premium templates
                      </p>
                      <p className="sub-text-feature">
                        <i class="fa fa-check" aria-hidden="true"></i> Share
                        your resume with friends and family
                      </p>
                      <p className="sub-text-feature">
                        <i class="fa fa-check" aria-hidden="true"></i> Access to
                        additional formatting and design options
                      </p>
                    </>
                  ) : props && props.popupType && props.popupType == "share" ? (
                    <>
                      <h4 className="header-feature mb-3">
                        Unlock Sharing and Features
                      </h4>
                      <p className="sub-text-feature mb-4">
                        Sorry, this feature is only available to users on our
                        premium plan. Upgrade now to unlock a variety of premium
                        templates and features, including:
                      </p>
                      <p className="sub-text-feature">
                        <i class="fa fa-check" aria-hidden="true"></i> Share
                        your resume with friends and family
                      </p>
                      <p className="sub-text-feature">
                        <i class="fa fa-check" aria-hidden="true"></i> Access to
                        additional formatting and design options
                      </p>
                    </>
                  ) : (
                    <>
                      <h4 className="maintitle">That’s a Pro feature!</h4>
                      <p className="titledesc prodesc">
                        {props && props.showProPopupMessage}
                      </p>
                    </>
                  )}
                </div>
                <div className="d-flex mt-3">
                  <button
                    className="btn primarybtn bgsuccess text-white p-2  mr-5"
                    onClick={handlePayment}
                  >
                    Upgrade Now
                  </button>
                  <button
                    className="btn outline-secondary  p-2 "
                    onClick={props.onHide}
                  >
                    Cancel
                  </button>
                </div>
                {/* <div className="col-md-12">
                  <button
                    className="btn primarybtn bgsuccess text-white p-14 w-100"
                    onClick={handlePayment}
                  >
                    Explore Pro Features
                  </button>
                </div> */}
              </div>
            </div>

            {/* {props && props.hideEditing ? (
              <div className="row justify-content-center">
                <div className="col-md-6">
                  <button
                    className="btn primarybtn bgsuccess text-white p-14 w-100"
                    onClick={handlePayment}
                  >
                    Explore Pro Features
                  </button>
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-md-6">
                  <button
                    className="btn primarybtn float-right w-75 mainborder"
                    onClick={props.onHide}
                  >
                    Continue Editing
                  </button>
                </div>
                <div className="col-md-6">
                  <button
                    className="btn primarybtn bgsuccess text-white p-14 w-75"
                    onClick={handlePayment}
                  >
                    Explore Pro Features
                  </button>
                </div>
              </div>
            )} */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Profeature;
